// extracted by mini-css-extract-plugin
export default {"containerVerticalStepper":"stepper-styles_containerVerticalStepper__QKEIf","verticalStepperSxElement":"stepper-styles_verticalStepperSxElement__0xObF"};